import { motion } from 'framer-motion';

const DURATION = 1;

const ThreeDotThinkingAnimated = () => {
  return (
    <div className="flex items-center justify-center gap-1">
      <motion.div
        className="h-2 w-2 rounded-full bg-gray-400"
        animate={{ opacity: [0.3, 1, 0.3] }}
        transition={{
          repeat: Infinity,
          repeatType: 'loop',
          duration: DURATION,
          ease: 'easeInOut',
        }}
      />
      <motion.div
        className="h-2 w-2 rounded-full bg-gray-400"
        animate={{ opacity: [0.3, 1, 0.3] }}
        transition={{
          repeat: Infinity,
          repeatType: 'loop',
          duration: DURATION,
          delay: 0.2,
          ease: 'easeInOut',
        }}
      />
      <motion.div
        className="h-2 w-2 rounded-full bg-gray-400"
        animate={{ opacity: [0.3, 1, 0.3] }}
        transition={{
          repeat: Infinity,
          repeatType: 'loop',
          duration: DURATION,
          delay: 0.4,
          ease: 'easeInOut',
        }}
      />
    </div>
  );
};

export default ThreeDotThinkingAnimated;
